import { Component, Prop, h, Element, State } from '@stencil/core';
import { IAceHeadlineTag } from '@ace/web-components';
import { hasSlot } from '@ace/web-components/dist_lib/utils';

@Component({
	tag: 'w2d-media-card',
	styleUrl: './w2d-media-card.scss',
	shadow: true,
})
export class W2dMediaCard {
	@Prop() headline: string;
	@Prop() headlineTag: IAceHeadlineTag = 'h3';
	// @Prop() body: string;
	@Prop({ mutable: true }) withHoverEffect: boolean = false;
	@Element() hostElement: HTMLElement;
	@State() _withHoverEffect = this.withHoverEffect;

	componentDidLoad() {
		this._withHoverEffect = !hasSlot(this.hostElement, 'cta');
	}

	private renderCtaSlot() {
		const hasCtaSlot = hasSlot(this.hostElement, 'cta');

		if (hasCtaSlot) {
			// If we have CTA then the hover must be forced false.
			return (
				<ace-card-buttons>
					<slot name='cta'></slot>
				</ace-card-buttons>
			);
		}
	}

	private renderMediaCardBody() {
		const hasBodySlot = hasSlot(this.hostElement, 'body');

		if (!hasBodySlot && !this.headline) {
			return null;
		}

		return (
			<div class='w2d-media-card__body'>
				{this.headline && (
					<ace-headline tag={this.headlineTag} type={'h3'}>
						{this.headline}
					</ace-headline>
				)}
				<slot name='body'></slot>
			</div>
		);
	}

	render() {
		return (
			<ace-card with-hover-effect={this._withHoverEffect} full-width={true}>
				<ace-card-body class='w2d-media-card'>
					<div>
						<slot name='media'></slot>
					</div>
					{this.renderMediaCardBody()}
				</ace-card-body>
				{this.renderCtaSlot()}
			</ace-card>
		);
	}
}
